import { Stack } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { AuthoringTailoredValue } from "../amends/components/authoring-tailored-value"
import { ChangeTitleRow } from "./change-title-row"
import { UNIT_OF_MEASURE_AMENDS_KEY } from "../amends/lib/constants/amends-keys"

export function AuthoringAudit({ taskTitle, auditKeys, original, tailored, displayPayload, entry }) {
    const FULL_WIDTH_CHIP_SX = {
        width: "100%",
        justifyContent: "normal",
    }
    const amendsKey = displayPayload?.amendsKey ?? displayPayload?.field

    return (
        <Stack spacing={1}>
            <ChangeTitleRow
                taskTitle={taskTitle}
                displayPayload={displayPayload}
                original={original}
                tailored={tailored}
                entry={entry}
            />
            <Repeat
                list={auditKeys.filter(
                    (key) => key !== UNIT_OF_MEASURE_AMENDS_KEY || amendsKey === UNIT_OF_MEASURE_AMENDS_KEY
                )}
                item={<AuthoringTailoredValue original={original} tailored={tailored} chipSx={FULL_WIDTH_CHIP_SX} />}
            />
        </Stack>
    )
}
